import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Tabs, Card, Result, Avatar, Tag } from 'antd';
import { Button, Input } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import {
	XContainer,
	XTabs1,
	XThemeCardFancy,
	XThemeCustomTabsTable,
} from '../../styles/GlobalThemeStyle';

// actions

import { checkModulePermissions } from '../../utils/helper';
import HeaderFile from '../../components/Header/HeaderFile';

import Header from '../../components/Header/Header';

import FilingManagement from './PreServiceFilingManagement';
import TabPane from 'antd/es/tabs/TabPane';
import { getCountByFilingAndRevenueApi } from '../../actions/getCountByFilingAndRevenueAction';
import {
	XThemeCardTitle1,
	XThemeCardTitle2,
} from '../Dashboard/DashboardStyle';
import { XTheme2InnerCard } from '../Dashboard/DashboardStyleCQ';
import { XTheme2CustomTabsTable } from '../../styles/GlobalThemeStyleCQ';

const CaseManagement = (props) => {
	const {
		getCountByFilingAndRevenueState,
		getCountByFilingAndRevenue,
		maProcessing,
		setMaProcessing,
	} = props;
	const navigate = useNavigate();
	const location = useLocation();

	const [activeTab, setActiveTab] = useState('all');
	const [filingStatusCount, setFilingStatusCount] = useState({
		escalation: 0,
		at_risk: 0,
		in_process: 0,
		untimely: 0,
	});
	const [filingStatus, setFilingStatus] = useState();
	const [revenueCycleCount, setRevenueCycleCount] = useState({
		pre_service: 0,
		post_claim: 0,
		part_b_drugs: 0,
		all: 0,
	});
	const onChange = (key) => {
		// Update the URL with the selected tab's value
		const queryParams = new URLSearchParams(window.location.search);
		queryParams.set('revenue_cycle', key);

		// Update other query parameters as needed
		queryParams.set('page', '1');
		queryParams.set('sort', 'createdAt');
		queryParams.set('sortDirection', 'descend');

		// Construct the new URL
		const newUrl = `${window.location.pathname}?${queryParams.toString()}`;

		// Push the new URL to the browser history
		window.history.pushState({}, '', newUrl);

		// Optionally, you can set the active tab state here if needed
		setActiveTab(key);
	};

	const handleClick = (filing_status) => {
		// Update the URL with the filing status
		const queryParams = new URLSearchParams(window.location.search);
		queryParams.set('filing_status', filing_status); // Assuming 'filing_status' is the query parameter to store the filing status

		// Construct the new URL
		const newUrl = `${window.location.pathname}?${queryParams.toString()}`;

		// Push the new URL to the browser history
		window.history.pushState({}, '', newUrl);
		setFilingStatus(filing_status);
		// window.location.reload();
	};

	const items = [
		{
			key: 'all',
			label: (
				<>
					All - <span>{revenueCycleCount.all}</span>
				</>
			),
			children: (
				<FilingManagement
					maProcessing={maProcessing}
					filingStatus={filingStatus}
				/>
			),
		},
		{
			key: 'pre_service',
			label: (
				<>
					Pre-Service - <span>{revenueCycleCount.pre_service}</span>
				</>
			),
			children: (
				<FilingManagement
					maProcessing={maProcessing}
					filingStatus={filingStatus}
				/>
			),
		},
		{
			key: 'post_claim',
			label: (
				<>
					Post Claim - <span>{revenueCycleCount.post_claim}</span>
				</>
			),
			children: (
				<FilingManagement
					maProcessing={maProcessing}
					filingStatus={filingStatus}
				/>
			),
		},
		{
			key: 'part_b_drugs',
			label: (
				<>
					Part B Drugs - <span>{revenueCycleCount.part_b_drugs}</span>
				</>
			),
			children: (
				<FilingManagement
					maProcessing={maProcessing}
					filingStatus={filingStatus}
				/>
			),
		},
	];

	useEffect(() => {
		getCountByFilingAndRevenue({
			for_page: maProcessing,
			// monitor_type: maProcessing ? maProcessing : 'ma_standard',
		});
	}, [window.location.search]);

	useEffect(() => {
		if (getCountByFilingAndRevenueState.apiState === 'success') {
			const data = getCountByFilingAndRevenueState.data;

			// Initialize an object to hold the updated counts
			const updatedRevenueCycleCount = {
				pre_service: 0,
				post_claim: 0,
				part_b_drugs: 0,
				all: 0,
			};
			const updatedFilingStatusCount = {
				escalation: 0,
				at_risk: 0,
				in_process: 0,
				untimely: 0,
			};

			// Iterate through the revenue_cycle array and update the counts
			data.revenue_cycle.forEach((item) => {
				updatedRevenueCycleCount[item._id] = item.count;
			});

			// Update the state with the new counts
			setRevenueCycleCount(updatedRevenueCycleCount);
			props.setAppealLetterApprovals(
				data.pending_appeal_letter_approvals,
			);

			// Iterate through the revenue_cycle array and update the counts
			data.filing_status.forEach((item) => {
				updatedFilingStatusCount[item._id] = item.count;
			});

			// Update the state with the new counts
			setFilingStatusCount(updatedFilingStatusCount);
		}
	}, [getCountByFilingAndRevenueState]);

	// use effects

	return (
		<>
			{checkModulePermissions(
				'ma-plan-appeals-processing',
			).sub_modules.includes('list-cases') ? (
				<>
					{maProcessing !== 'appeal_letter_approvals' && (
						<XTheme2InnerCard className="mb-3">
							<Row gutter={(15, 15)}>
								<Col
									xs={24}
									md={8}
									lg={8}
									className="mb-3 mb-lg-0"
								>
									<div
										className="insideCard borderRight cursorPointer"
										onClick={() => handleClick('at_risk')}
									>
										<div className="imgWrapper">
											<img
												className="img-fluid"
												src="./images/at_risk.svg"
												alt=""
											/>
										</div>
										<div className="textWrapper">
											<span className="title fontSize30">
												At Risk
											</span>
											<div className="numberWrapper">
												{filingStatusCount.at_risk}
											</div>
										</div>
									</div>
								</Col>
								<Col
									xs={24}
									md={8}
									lg={8}
									className="mb-3 mb-lg-0"
								>
									<div
										className="insideCard borderRight cursorPointer"
										onClick={() =>
											handleClick('in_process')
										}
									>
										<div className="imgWrapper">
											<img
												className="img-fluid"
												src="./images/in_process.svg"
												alt=""
											/>
										</div>
										<div className="textWrapper">
											<span className="title fontSize30">
												In Process
											</span>
											<div className="numberWrapper">
												{filingStatusCount.in_process}
											</div>
										</div>
									</div>
								</Col>
								<Col xs={24} md={8} lg={8}>
									<div
										className="insideCard cursorPointer"
										onClick={() => handleClick('untimely')}
									>
										<div className="imgWrapper">
											<img
												className="img-fluid"
												src="./images/timer.svg"
												alt=""
											/>
										</div>
										<div className="textWrapper">
											<span className="title fontSize30">
												Untimely
											</span>
											<div className="numberWrapper">
												{filingStatusCount.untimely}
											</div>
										</div>
									</div>
								</Col>
							</Row>
						</XTheme2InnerCard>
					)}
					<Row gutter={(15, 15)}>
						<Col xs={24}>
							{maProcessing !== 'appeal_letter_approvals' ? (
								<XTheme2CustomTabsTable
									type="card"
									activeKey={activeTab}
									onChange={onChange}
									className="hello child-tabs"
								>
									{items.map((item) => (
										<TabPane
											tab={item.label}
											key={item.key}
										>
											{activeTab === item.key &&
												item.children}
										</TabPane>
									))}
								</XTheme2CustomTabsTable>
							) : (
								<XTheme2InnerCard
									className="mb-3"
									bodyStyle={{ padding: '20px 0px' }}
								>
									<FilingManagement
										maProcessing={maProcessing}
										filingStatus={filingStatus}
									/>
								</XTheme2InnerCard>
							)}
						</Col>
					</Row>
				</>
			) : (
				<Result
					status="403"
					title="403"
					subTitle="Sorry, you are not authorized to access this page."
					extra={
						<Button type="primary" onClick={() => navigate('/')}>
							Back Home
						</Button>
					}
				/>
			)}
		</>
	);
};

const mapStateToProps = (state) => ({
	getCountByFilingAndRevenueState: state.getCountByFilingAndRevenue,
});

const mapDispatchToProps = (dispatch) => ({
	getCountByFilingAndRevenue: (data) =>
		dispatch(getCountByFilingAndRevenueApi(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CaseManagement);
